//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WorkOrderLogs from "./componets/workOrderLogs";
import ImageUploader from "../../../components/ImageUploader";
import RepairDetailPaidanView from "./repair/repair-detail-paidan-view";
import ChargebackPopupView from "./componets/chargeback-popup-view";
import TransferOrderPopupView from "./repair/transferOrder-popup-view";
import ReturnVisitPopupView from "./repair/returnVisit-popup-view";
import ChaosongPopupView from "./componets/chaosong-popup-view";
import PageWorkOrderInfo from "./componets/page-workOrder-info";
import PageActionButton from "./componets/page-action-button";
import SelectCompanyPopup from "./componets/select-company-popup";
import {startHandleAndPaiDan} from '../../../api/workOrder'
import PagePaiDanView from "./componets/page-PaiDan-view";
import PageResultView from "./componets/page-result-view";
import ShangmenView from "./componets/shangmen-view";
import PageStartView from "./componets/page-start-view";


export default {
    name: "workSheetDetail",
    components: {
        PageStartView,
        ShangmenView,
        PageResultView,
        PagePaiDanView,
        SelectCompanyPopup,
        PageActionButton,
        PageWorkOrderInfo,
        ChaosongPopupView,
        ReturnVisitPopupView,
        TransferOrderPopupView,
        // WeixiuPopupView,
        RepairDetailPaidanView,
        ChargebackPopupView,
        // DutyView,
        ImageUploader,
        WorkOrderLogs
    },
    filters: {
        // formatDate(time, type) {
        //     let date = new Date(time);
        //     if (type === 1) {
        //         return formatDate(date, 'yyyy/MM/dd');
        //     }
        //     return formatDate(date, 'yyyy-MM-dd hh:mm');
        // }
    },
    data() {
        return {
            // show: false,
            value: '',
            // showFeedback: false,
            workOrderInfo: {
                fileIds: [],
                workOrderNo: ''
            },
            id: 0,
            // permission: {},
            // downloadUrl: util.ApiUrl + '/file/download/',
            // nodes: [],
            // showShangMenPopup: false,
            showWeiXiuPopup: false,
            showChargebackPopup: false,
            showtransferOrderPopup: false,
            showReturnVisitPopup: false,
            showChaoSongPopup: false,
            jieDanPopup: false,
            companyPopup: false,
            currentUser: {
                userId: 0
            }
        }
    },
    computed: {
        permission() {
            return this.$store.state.workOrder.memberPermission;
        }
    },
    methods: {
        /*工单信息*/
        getWorkOrderById() {
            this.$toast.loading({
                duration: 0,
                message: ''
            });
            this.$store.dispatch({
                type: 'workOrder/getWorkOrderById',
                id: this.id
            }).then((res) => {
                this.workOrderInfo = this.$store.state.workOrder.workOrderInfo;
                // this.init();
            }).finally(() => {
                this.$toast.clear();
            })
        },

        /*工单处理日志*/
        reloadWorkOrderLogs() {
            this.getWorkOrderById();
            this.$refs.workOrderLogsRef.getLogs();
        },

        // init() {
        //     if (this.workOrderInfo.workOrderType === 1) {
        //         this.getSeverities();
        //         this.getReasons();
        //         this.getComplaintCategories('投诉分类');
        //     } else if (this.workOrderInfo.workOrderType === 2) {
        //         // this.getComplaintCategories('报修分类');
        //     } else if (this.workOrderInfo.workOrderType === 0) {
        //         this.getComplaintCategories('咨询分类');
        //     }
        // },

        /*受理*/
        onShowAcceptPopup() {
            // this.show = true;
            this.$refs.startViewRef.onShowPopup()
        },


        checkerPermission() {
            this.$store.dispatch({
                type: 'workOrder/memberPermission',
                id: this.id
            })
        },

        showEditResult(r) {
            let data = {
                image: {
                    associateType: 'WorkOrderResult'
                },
            };
            data = r;
            data.image = {associateType: 'WorkOrderResult'};
            data.isDelayEnd = false;
            this.$refs.resultViewRef.showResultPopup(data)
        },

        formatDate(date) {
            let m = date.getMonth() + 1;
            if (m < 10) {
                m = '0' + m;
            }
            var d = date.getDate();
            if (d < 10) {
                d = '0' + d;
            }
            return `${date.getFullYear()}-${m}-${d}`;
        },

        // getOrganizationUnitAllUsers() {
        // if (this.workOrderInfo.organizationId <= 0) {
        //     return
        // }
        // abp.ajax.get('api/services/app/OrganizationUnit/GetAllUsers?organizationId=' + this.workOrderInfo.organizationId)
        //     .then(res => {
        //         this.organizationUnitAllUsers = [];
        //         this.organizationUnitAllUsers.push(...res.data.result)
        //         this.organizationUnitAllUsers.forEach(item => {
        //             item.text = item.name;
        //         })
        //     })
        //     .finally(() => {
        //
        //     })
        // },

        paiDanCount(l) {

        },
        /*刷新工单+日志*/
        workOrderReload() {
            this.getWorkOrderById();
            this.reloadWorkOrderLogs()
            this.$refs.paiDanRecordRef.getPaiDans(this.id)
        },
        onShowReturnVisitPopup(d) {
            this.showReturnVisitPopup = true;
            this.$refs.returnVisitPopupRef.setDto(d);
        },
        onShowChaoSongPopup(m) {
            this.showChaoSongPopup = true
        },

        /*接单*/
        onJieDan(data) {
            // this.jieDanPopup = true
        },

        /*派单*/
        showDispatchPopup() {
            this.$refs.paiDanViewRef.showDispatchPopup();
        },

        /*派工*/
        showPaiGongPopup() {
            this.$refs.paiDanViewRef.showPaiGongPopup();
        },

        // getBuildingRepairer() {
        //     this.$store.dispatch({
        //         type: 'workOrder/getBuildingRepairer',
        //         id: this.id
        //     })
        // },

        onShowShangMenPopup(data) {
            this.$refs.shangMenViewRef.show(data)
        },

        onShowPaiDanReturnOrderPopup() {
            this.$refs.paiDanViewRef.showPaiDanReturnOrderPopup();
        },

        onShowSelectCompanyPopup() {
            this.companyPopup = true;
        },
        onCompanySelected() {
            this.companyPopup = false;
            this.getWorkOrderById();
        },
        onShowSplitView() {
            this.$router.push({
                name: 'workOrder-split'
            })
        },
        getCurrentUserByMember() {
            abp.ajax.get('/api/services/app/WorkOrder/GetCurrentUserByMember').then(res => {
                if (res.data.result != null) {
                    this.currentUser = res.data.result;
                }
            })
        },
    },
    created() {
        this.getCurrentUserByMember();
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getWorkOrderById();
        }
        this.checkerPermission();
    }
}
